import { CacheKey } from "@esignal/polygon-service-api";
import { CacheKey_truncRight } from "./CacheKey_truncRight";

export const CacheKey_toString = (entry: CacheKey) => {
	return JSON.stringify(CacheKey_truncRight(entry));
};
